import groq from 'groq'

export const ArticlesTypeQuery = groq`
  _type == "ArticlesType" => {
    ...,
    "articles": select(
      view == "newest" => *[_type == "article"] | order(date desc)[0...24]{
        title,
        "slug": slug.current,
        date,
        "image": image.asset->url
      },
      view == "manual" => articles[]->{
        title,
        "slug": slug.current,
        date,
        "image": image.asset->url
      },
      view == "all" => *[_type == "article"] | order(date desc){
        title,
        "slug": slug.current,
        date,
        "image": image.asset->url
      }
    )
  }
`
